import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { AppCommonService } from '../appcommon.service';
import { IBlog, IArticle } from '../blogs/blog';
import { BlogService } from '../blogs/blog.service';

@Component({
  selector: 'mft-relateddrivernews',
  templateUrl: "./relateddrivernews.component.html"
})
export class RelatedDriverNewsComponent implements OnInit, AfterViewInit {
  @Input() articlesList: IArticle[];
  constructor(private authService: AuthService,
    private appCommonService: AppCommonService,
    private router: Router
  ) {

  }
  ngOnInit() {

  }

  ngAfterViewInit() {

  }
}



// WEBPACK FOOTER //
// ./src/app/home/relateddrivernews.component.ts